import { useState } from 'react';

import Button from '@ingka/button';
import FormField from '@ingka/form-field';
import Modal, { ModalBody, ModalFooter, ModalHeader, Sheets } from '@ingka/modal';
import TextArea from '@ingka/text-area';
import { translate } from '@repo/phrase';

const COMMENT_MAX_LENGTH = 600;

interface Props {
    visible: boolean;
    onClose: () => void;
    attachmentComment: string;
    onConfirm: (comment: string) => void;
    isPending: boolean;
}

export const AttachmentCommentModal = ({ visible, onClose, attachmentComment, onConfirm, isPending }: Props) => {
    const [comment, setComment] = useState<string>(attachmentComment);

    const handleConfirm = () => {
        onConfirm(comment);
    };

    const handleClose = () => {
        setComment(attachmentComment);
        onClose();
    };

    return (
        <Modal
            handleCloseBtn={handleClose}
            visible={visible}
            focusLockProps={{ autoFocusReturn: false, autoFocus: true }}
            data-testid="attachment-comment-modal"
        >
            <Sheets
                aria-label={translate('attachments_comment_modal_title')}
                header={<ModalHeader title={translate('attachments_comment_modal_title')} />}
                footer={
                    <ModalFooter>
                        <Button
                            type="primary"
                            text={translate('attachments_comment_save')}
                            onClick={handleConfirm}
                            loading={isPending}
                            disabled={!comment.trim()}
                            data-testid="attachment-comment-save"
                        />
                    </ModalFooter>
                }
            >
                <ModalBody>
                    <FormField characterLimit={COMMENT_MAX_LENGTH}>
                        <TextArea
                            id="attachment-comment-textarea"
                            data-testid="attachment-comment-textarea"
                            label={translate('attachments_comment_label')}
                            value={comment}
                            onChange={(e) => {
                                setComment(e.target.value);
                            }}
                        />
                    </FormField>
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
